export const iconFontAwesomeCharityHandHoldingHeart = (
	<i className="fa-solid fa-hand-holding-heart"></i>
);
